// extracted by mini-css-extract-plugin
export default {"controlRow":"MGInput_controlRow__25jY+","leftIcon":"MGInput_leftIcon__UckqV","rightIcon":"MGInput_rightIcon__ORCtL","rightIconButton":"MGInput_rightIconButton__rm1+f"};